export enum DISTANCE_UNIT {
  KM = 'km',
  MI = 'mi'
}